/**
 * @author        patrick@zumper.com (Patrick Giddings)
 * @copyright     Copyright (c) 2023, Zumper
 * @description   returns payloadReducer with correct types
 */

import type { PayloadAction } from '@reduxjs/toolkit'
import { payloadReducer } from '@zcode/reducers'

export function createTypedPayloadReducer<State>(): typeof payloadReducer<
  State,
  PayloadAction<State>
> {
  return payloadReducer
}
